<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous réactiver le maitrise <strong>{{maitrise.nom}} {{maitrise.prenom}} </strong> - <strong>{{maitrise.arrondissement_id | arrondissementName}}</strong> ?
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Réactiver
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'

export default {
  props: [
    'maitrise',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('reactivateMaitrise', this.maitrise)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// MaitrisesReactivate.vue?090d6634